// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var RandomId$ReactHooksTemplate = require("./RandomId.res.js");

function decode(json) {
  return {
          text: Json_decode.withDefault("", (function (param) {
                  return Json_decode.field("text", Json_decode.string, param);
                }), json)
        };
}

function make(text) {
  return {
          id: undefined,
          uuid: RandomId$ReactHooksTemplate.generate(),
          text: text,
          image: undefined,
          translations: /* [] */0,
          title: "Thank you for your feedback!"
        };
}

function empty(param) {
  return {
          id: undefined,
          uuid: RandomId$ReactHooksTemplate.generate(),
          text: "",
          image: undefined,
          translations: /* [] */0,
          title: "Thank you for your feedback!"
        };
}

function text(t) {
  return t.text;
}

function title(t) {
  return t.title;
}

function getTextTranslation(t, language) {
  var translation = List.find_opt((function (param) {
          return param[0] === language;
        }), t.translations);
  if (translation !== undefined) {
    return translation[1].text;
  } else {
    return t.text;
  }
}

function setText(t, text) {
  return {
          id: t.id,
          uuid: t.uuid,
          text: text,
          image: t.image,
          translations: t.translations,
          title: t.title
        };
}

function setTitle(t, title) {
  return {
          id: t.id,
          uuid: t.uuid,
          text: t.text,
          image: t.image,
          translations: t.translations,
          title: title
        };
}

function image(t) {
  return t.image;
}

function uuid(t) {
  return t.uuid;
}

function id(t) {
  return t.id;
}

function duplicate(t) {
  return {
          id: undefined,
          uuid: RandomId$ReactHooksTemplate.generate(),
          text: t.text,
          image: t.image,
          translations: t.translations,
          title: t.title
        };
}

function toJson(destroyOpt, position, t) {
  var destroy = destroyOpt !== undefined ? destroyOpt : false;
  return Json_encode.object_({
              hd: [
                "text",
                t.text
              ],
              tl: {
                hd: [
                  "position",
                  position
                ],
                tl: {
                  hd: [
                    "id",
                    Json_encode.nullable((function (prim) {
                            return prim;
                          }), t.id)
                  ],
                  tl: {
                    hd: [
                      "uuid",
                      RandomId$ReactHooksTemplate.toJson(t.uuid)
                    ],
                    tl: {
                      hd: [
                        "title",
                        t.title
                      ],
                      tl: {
                        hd: [
                          "_destroy",
                          destroy
                        ],
                        tl: /* [] */0
                      }
                    }
                  }
                }
              }
            });
}

function decodeTranslation(json) {
  return [
          Json_decode.field("survey_language", (function (param) {
                  return Json_decode.field("name", Json_decode.string, param);
                }), json),
          Json_decode.field("key_string_mapping", decode, json)
        ];
}

function fromJson(json) {
  return {
          id: Json_decode.optional((function (param) {
                  return Json_decode.field("id", Json_decode.$$int, param);
                }), json),
          uuid: Json_decode.field("uuid", RandomId$ReactHooksTemplate.fromJson, json),
          text: Json_decode.field("text", Json_decode.string, json),
          image: Json_decode.field("img_url", (function (param) {
                  return Json_decode.optional(Json_decode.string, param);
                }), json),
          translations: Json_decode.field("translations", (function (param) {
                  return Json_decode.list(decodeTranslation, param);
                }), json),
          title: Json_decode.withDefault("", (function (param) {
                  return Json_decode.field("title", Json_decode.string, param);
                }), json)
        };
}

var categoryType = "thank_you";

exports.categoryType = categoryType;
exports.make = make;
exports.empty = empty;
exports.text = text;
exports.title = title;
exports.getTextTranslation = getTextTranslation;
exports.image = image;
exports.uuid = uuid;
exports.id = id;
exports.setText = setText;
exports.setTitle = setTitle;
exports.toJson = toJson;
exports.fromJson = fromJson;
exports.duplicate = duplicate;
/* RandomId-ReactHooksTemplate Not a pure module */
